/**
 * 活动：私立学校 / 活动 / 兑换 / 定制 / 信息采集
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/private_school',
    name: 'privateSchool',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/mall/privateSchool.vue'
      ),
    meta: {
      title: '节日礼包'
    }
  },
  {
    path: '/activity',
    name: 'activity',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/activity/index.vue'
      ),
    meta: {
      title: '节日礼包'
    }
  },
  {
    // 兑换专区（参考 mall_h5 路由 /exchange）：分类兑换 / 无分类兑换两种模式合并
    // 独立路由，不修改原有 /activity 与 /partition（老链接行为不变）
    path: '/exchange',
    name: 'exchangeActivity',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/activity/exchange.vue'
      ),
    meta: {
      title: '礼包列表'
    }
  },
  {
    path: '/customization',
    name: 'customization',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/customization/index.vue'
      ),
    meta: {
      title: '企业定制',
      isCommon: true,
      alone: true
    }
  },
  {
    path: '/infoGathering',
    name: 'infoGathering',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/customization/infoGathering.vue'
      ),
    meta: {
      title: '企业定制-无卡兑换',
      isCommon: true,
      alone: true
    }
  }
];
